export interface TabularPrediction {
  prediction: unknown;
  confidence?: number | null;
  proba?: Record<string, number> | null;
  quantiles?: Record<string, number> | null;
  [key: string]: unknown;
}

export interface ResultTabularProps {
  predictions: TabularPrediction[];
}

function fmtPct(v: unknown): string {
  if (typeof v !== "number" || !Number.isFinite(v)) return "—";
  return `${(v * 100).toFixed(1)}%`;
}

function fmtPred(v: unknown): string {
  if (v === null || v === undefined) return "—";
  if (typeof v === "number") return v.toString();
  return String(v);
}

export function ResultTabular({ predictions }: ResultTabularProps) {
  if (predictions.length === 0) {
    return <div className="text-xs text-fg-muted">No predictions returned.</div>;
  }

  const hasConfidence = predictions.some((p) => p.confidence != null);
  const hasProba = predictions.some((p) => p.proba != null);

  return (
    <table className="w-full text-xs">
      <thead>
        <tr className="text-left text-fg-muted border-b border-border">
          <th className="py-1.5 pr-3">#</th>
          <th className="py-1.5 pr-3">Prediction</th>
          {hasConfidence && <th className="py-1.5 pr-3">Confidence</th>}
          {hasProba && <th className="py-1.5">Probabilities</th>}
        </tr>
      </thead>
      <tbody>
        {predictions.map((p, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: predictions have no stable ID
          <tr key={i} className="border-b border-border/60">
            <td className="py-1.5 pr-3 font-mono text-fg-dim">{i + 1}</td>
            <td className="py-1.5 pr-3 font-mono">{fmtPred(p.prediction)}</td>
            {hasConfidence && (
              <td className="py-1.5 pr-3 font-mono tnum">{fmtPct(p.confidence)}</td>
            )}
            {hasProba && (
              <td className="py-1.5">
                {p.proba ? (
                  <div className="flex flex-wrap gap-1">
                    {Object.entries(p.proba).map(([k, v]) => (
                      <span
                        key={k}
                        className="inline-flex items-center gap-1 rounded border border-border bg-surface-2 px-1.5 py-0.5 font-mono text-[10px]"
                      >
                        <span>{k}:</span>
                        <span className="tnum">{fmtPct(v)}</span>
                      </span>
                    ))}
                  </div>
                ) : (
                  <span className="text-fg-dim">—</span>
                )}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
